import { IonFabButton } from "@ionic/react";
import { useIntl } from "react-intl";
import { useLocation } from "react-router";

import "@components/DataUnread.module.css";
import Icon from "@components/text/Icon";
import useGlobalOpener from "@hooks/useGlobalOpener";
import useUnreadMessagesCount from "@hooks/useUnreadMessagesCount";
import { OpenerTypeEnum } from "@typing/Enums";

type Props = {
  journeyId: string;
};

const MessagesFab = ({ journeyId }: Props) => {
  const intl = useIntl();
  const location = useLocation();
  const messagesOpener = useGlobalOpener(OpenerTypeEnum.MESSAGES);
  const unreadMessageCountData = useUnreadMessagesCount(journeyId);

  if (location.pathname.includes("/messages")) {
    return null;
  }

  return (
    <IonFabButton
      {...unreadMessageCountData}
      aria-label={intl.formatMessage({ id: "accessibility.ariaLabels.toggleMessages" })}
      className="ion-hide-lg-down"
      color="secondary-500"
      onClick={messagesOpener.toggle}
    >
      <Icon color="white" icon="messages" />
    </IonFabButton>
  );
};

export default MessagesFab;
